import React from 'react';
import PropTypes from 'prop-types';
import {Variant} from 'constants/UIComponentEnum';
import FastButton from 'components/FastButton';

function SetupWizardStepButton({label, onClick, ...props}) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <FastButton fitContainer height="2.4rem" variant={Variant.OUTLINE} onClick={onClick} label={label} {...props} />
  );
}

SetupWizardStepButton.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default SetupWizardStepButton;
